/* ============================================================
   Configurador de cadenas portacables — asistente por pasos.
   Datos en window.CPC_DATOS (assets/configurador-cadenas-datos.js).

   Un paso visible a la vez; el raíl deja volver a los ya completados.
   Todos los botones llevan type="button": la sección tiene un
   {% form 'contact' %} y un botón sin tipo lo enviaría.

   ────────────────────────────────────────────────────────────
   POR QUÉ EL ORDEN ES ÉSTE
   ────────────────────────────────────────────────────────────
   Antes empezaba preguntando la FAMILIA, que es justo lo que el cliente no sabe, y
   pedía los cables dos pasos DESPUÉS de haber elegido la anchura — o sea que la
   anchura se elegía a ciegas y luego se comprobaba contra el dato que la determina.

   Ahora el paquete de cables es la entrada y la cadena es la consecuencia:

     cables → instalación → familia → anchura → radio → longitud → accesorios → resumen

   Es el orden del propio configurador de Murrplastik (mympchain.com), que pregunta
   Aplicaciones → Cables → Tipo de instalación → Modelo → Cadena. Y su vía de
   selección rápida por clave de pedido la avisa como «solo recomendado si sabe
   exactamente qué cadena necesita»: aquí es el atajo del paso 1, no la puerta grande.

   ────────────────────────────────────────────────────────────
   DE DÓNDE SALEN LOS LÍMITES
   ────────────────────────────────────────────────────────────
   Los techos de velocidad y aceleración y el rango de temperatura son los que
   Murrplastik publica en su propio configurador. No son criterios nuestros:

     autoportante   máx. 20 m/s   y   50 m/s²
     deslizante     máx.  6 m/s   y   25 m/s²
     temperatura    de −30 °C a 120 °C, y 135 °C por poco tiempo

   Para la aceleración LATERAL Murrplastik no publica techo propio, así que se
   compara con el horizontal y se dice que es prestado. Inventar un número aquí
   sería peor que no comprobarlo.

   Y la regla que OBLIGA un accesorio —anchura interior ≥ 246 mm exige conector de
   traviesas— también es suya, literal de su configurador.

   La holgura del 10 % en anchura y el 80 % de altura aprovechable son los criterios
   que ya usaba la revisión de este configurador; se mantienen para que la
   recomendación y el aviso no se contradigan.

   ────────────────────────────────────────────────────────────
   LO QUE ESTO NO HACE
   ────────────────────────────────────────────────────────────
   No valida vano sin apoyo, flecha, carga admisible ni vida útil. La dinámica y la
   temperatura se comprueban contra los techos de gama, no contra la curva de la
   familia concreta, que la tarifa no trae. Es una preselección, y así se dice.
   ============================================================ */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-cpc]');
  if (!raiz || !window.CPC_DATOS) return;
  var D = window.CPC_DATOS;
  var META = window.CPC_META || {};

  /* ---------- utilidades ---------- */
  var $ = function (s, c) { return (c || raiz).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || raiz).querySelectorAll(s)); };
  function el(t, p, hijos) {
    var n = document.createElement(t);
    for (var k in p) { if (k === 'text') n.textContent = p[k]; else if (k === 'html') n.innerHTML = p[k]; else n.setAttribute(k, p[k]); }
    (hijos || []).forEach(function (h) { if (h) n.appendChild(h); });
    return n;
  }
  function eur(v) { return v.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function nm(v, d) { return v.toLocaleString('es-ES', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
  function ordNum(a) { return a.slice().sort(function (x, y) { return parseFloat(x) - parseFloat(y); }); }
  function pad3(x) { x = String(x); while (x.length < 3) x = '0' + x; return x; }
  /* Las familias tipo MP 3000 llevan la anchura en el nombre (MP 3001, MP 3002…),
     así que no hay milímetros que mostrar: se etiqueta con la designación. */
  function esDesignacion(a) { return /^\d{4}$/.test(a); }
  function anchLbl(a) { return esDesignacion(a) ? 'MP ' + a : a + ' mm'; }
  function anchRef(a) { return esDesignacion(a) ? 'MP ' + a : pad3(a); }

  /* ---------- criterios ----------
     Los de altura son de Murrplastik, de las ayudas de su propio ChainBuilder:

       minHiInfo — «la altura interior mínima sale del diámetro máximo de los cables. Para
       que los cables se puedan mover hay que dejar una reserva por cable, que es
       aproximadamente el 20 % del diámetro exterior.»

       minBiInfo — «los cables deben ir individualmente y uno al lado del otro. Hay que
       asegurar que NO puedan montarse unos encima de otros. La altura interior libre (Hi)
       de la cadena debe ser MENOR que la suma de dos cables contiguos: Hi < D1 + D2.»

     La segunda es la que faltaba, y va en dirección contraria a la intuición: una cadena
     DEMASIADO ALTA también está mal, porque deja sitio para que los cables se apilen y se
     estrangulen entre ellos. Antes solo se comprobaba que no fuera demasiado baja.

     La altura de la tarifa ES la interior: su tienda etiqueta ese filtro «Altura interior»
     y muestra las familias como «MP 10.1 (10 mm)». */
  var HOLGURA = 0.9;      /* de la anchura interior se aprovecha el 90 % */
  var RESERVA_H = 1.2;    /* Hi mínima = diámetro mayor + 20 % de reserva */
  var BI_TRAVIESAS = 246; /* mm de anchura interior desde los que Murrplastik exige conector */
  var HI_CERRADA = 74;    /* «Cerrado (con tapas/cubiertas) (max. HI=74 mm)», literal de su formulario */
  var HI_TOPE = 104, BI_TOPE = 600;   /* límites globales de su ChainBuilder */
  var TEMP = { min: -30, max: 120, corta: 135 };
  var FACTORES_R = [7.5, 10, 12.5];

  /* ────────────────────────────────────────────────────────────
     EL MODELO DE SELECCIÓN DE MURRPLASTIK, TAL CUAL
     ────────────────────────────────────────────────────────────
     Leído de su propio ChainBuilder: `POST /application/ajax/getAllParametersForForm`
     con `formId=chainMaterialForm` o `chainLineForm` devuelve el HTML del paso con sus
     opciones. Los textos de aquí son los suyos, en español, sin retocar.

     ⚠ LO QUE NO SE PUEDE COPIAR: su servidor devuelve `disabled` en cada opción según lo
     que ya has elegido, o sea que es su BASE DE DATOS la que sabe qué familia aguanta qué
     ambiente y qué material. Nosotros no la tenemos. Así que el ambiente y la conformidad
     se PREGUNTAN y viajan en la solicitud, pero NO filtran: filtrar con un dato que no
     tenemos sería inventarse el resultado. */
  var INSTALACIONES = {
    hor: [
      ['1', 'Autosoportada horizontal', 'el tramo va en el aire'],
      ['3', 'Horizontal deslizante', 'apoyada sobre sí misma o en canal'],
      ['4', 'Horizontal con soporte', 'con apoyo intermedio'],
      ['6', 'Tumbada 90º (sin soporte)', 'de canto, sin apoyo'],
      ['14', 'Tumbada 90º (con soporte)', 'de canto, con apoyo']
    ],
    ver: [
      ['10', 'Vertical en U invertida', 'colgando'],
      ['11', 'Vertical en forma de U', 'de pie']
    ]
  };
  /* Murrplastik publica techos de dinámica SOLO para «autoportante» (20 m/s, 50 m/s²) y
     «deslizante» (6, 25). No da uno por variante. Así que se aplica el techo cuando la
     variante lo dice sin ambigüedad, y para las demás el ESTRICTO, diciendo que es la
     opción prudente y no un dato suyo. */
  var TECHOS = {
    '1':  { nombre: 'autoportante', vel: 20, acel: 50, cierto: true },
    '3':  { nombre: 'deslizante', vel: 6, acel: 25, cierto: true },
    '4':  { nombre: 'con soporte', vel: 6, acel: 25, cierto: false },
    '6':  { nombre: 'tumbada sin soporte', vel: 6, acel: 25, cierto: false },
    '14': { nombre: 'tumbada con soporte', vel: 6, acel: 25, cierto: false },
    '10': { nombre: 'vertical en U invertida', vel: 6, acel: 25, cierto: false },
    '11': { nombre: 'vertical en U', vel: 6, acel: 25, cierto: false }
  };
  var AMBIENTE = [
    ['lowNoise', 'Pequeña emisión de ruidos'],
    ['outdoor', 'Instalación exterior'],
    ['dust', 'Polvo / suciedad leve'],
    ['dirt', 'Suciedad'],
    ['welding', 'Salpicaduras de soldadura / virutas calientes'],
    ['soporteLateral', 'Sistemas de soporte lateral']
  ];
  var MAT_CADENA = [['1', 'PA (estándar)', 'poliamida'], ['4', 'ESD', 'disipativa']];
  var MAT_TRAVIESA = [['0', 'Cualquiera', 'plástico o aluminio'], ['1', 'Plástico', null], ['2', 'Aluminio', null]];
  var CIERRES = [
    ['igual', 'Me da igual', null],
    ['0', 'Abierta (con traviesas)', 'se cablea desde arriba'],
    ['1', 'Cerrada (con tapas)', 'protegida; máx. ' + HI_CERRADA + ' mm de alto']
  ];
  /* Las seis de Murrplastik, literales. Fíjate en «o en ambos lados» y en «se permite no
     abrible»: son PREFERENCIAS CON TOLERANCIA, no un filtro. Montarlas como filtro que
     descarta fue mi error en la primera versión de este paso. */
  var APERTURAS = [
    ['igual', 'Me da igual', null],
    ['0', 'Preferiblemente sin apertura', null],
    ['1', 'Abrible libremente; se permite no abrible', null],
    ['2', 'Solo por el interior o en ambos lados', null],
    ['3', 'Solo por el exterior o en ambos lados', null],
    ['4', 'Dentro y fuera', null],
    ['5', 'Abrible libremente', null]
  ];
  var NORMAS = [
    ['', 'Ninguna', null], ['25558', 'Mercedes-Benz Powertrain', null],
    ['969665', 'Conductix Wampfler', null], ['924466', 'TKD', null], ['22525', 'FLT', null]
  ];

  /* ---------- estado ---------- */
  /* 'invitado' | 'cliente' | 'b2b'. Lo pone el Liquid en el data-attribute. */
  var SESION = raiz.getAttribute('data-cpc-sesion') || 'invitado';

  function estadoInicial() {
    return {
      /* 1 · cables */
      cables: [{ n: 6, d: 12.5, t: '' }],
      sinCables: false,
      factorR: 10,
      pesoM: 0,          /* kg/m del paquete de cables, fluido incluido */
      /* 3 · lo que el cliente necesita de la cadena, no qué familia quiere */
      cierre: 'igual', aperturaQ: 'igual', matTraviesa: '0', verTodas: false,
      prioridad: 'igual',
      /* 2 · instalación, ambiente y material — el modelo de Murrplastik entero */
      orient: 'hor', instalacion: '1',
      amb: {}, matCadena: '1', norma: '',
      vel: 2, acel: 8, velV: 0, acelV: 0, acelLat: 0,
      tMin: -10, tMax: 60, tCorta: 0,
      /* 3-5 · la cadena */
      fam: null, anchura: null, radio: null, tipo: null,
      /* 6 · longitud */
      modo: 'rec', recorrido: 3000, largo: 2000, eslabRaw: 30,
      fp: 'centro', fpE: 0, nRr: 0, uds: 1,
      /* 7 · accesorios */
      acc: {}
    };
  }
  var S = estadoInicial();
  var paso = 0;
  var PASOS = ['cables', 'instalacion', 'cadena', 'anchura', 'radio', 'longitud', 'accesorios', 'resumen'];
  function f() { return D[S.fam]; }
  function lim() { return TECHOS[S.instalacion] || TECHOS['3']; }
  /* Deslizante en el sentido de «va apoyada»: es lo que hace que valga la pena mirar si la
     familia lleva carriles de deslizamiento. La 1 (autosoportada) es la única que no. */
  function apoyada() { return S.instalacion !== '1'; }
  function instLbl() {
    var l = (INSTALACIONES[S.orient] || []).filter(function (x) { return x[0] === S.instalacion; })[0];
    return l ? l[1] : S.instalacion;
  }
  function ambLista() {
    return AMBIENTE.filter(function (a) { return S.amb[a[0]]; }).map(function (a) { return a[1]; });
  }

  /* ---------- 1 · el paquete de cables manda ----------
     De aquí sale lo que hay que pedirle a la cadena: cuánta anchura interior, cuánta
     altura y qué radio mínimo. Es el cambio de fondo respecto a la versión anterior. */
  function paquete() {
    var dTot = 0, n = 0, ds = [];
    S.cables.forEach(function (x) {
      if (!(x.d > 0) || !(x.n > 0)) return;
      dTot += x.n * x.d; n += x.n;
      for (var i = 0; i < x.n; i++) ds.push(x.d);
    });
    ds.sort(function (a, b) { return b - a; });
    var dMax = ds.length ? ds[0] : 0;
    /* Los DOS mayores, que son los que fijan el techo de altura por la regla Hi < D1+D2.
       Con un solo cable el segundo es él mismo: la regla queda Hi < 2·D, que es lo que
       tiene sentido —con un cable no hay nada que se pueda apilar sobre él. */
    var dos = ds.length > 1 ? ds[0] + ds[1] : dMax * 2;
    return {
      dTot: dTot, dMax: dMax, n: n, dos: dos,
      hay: dTot > 0,
      anchoNec: dTot > 0 ? dTot / HOLGURA : 0,
      altoMin: dMax > 0 ? dMax * RESERVA_H : 0,
      altoMax: dos,                                  /* la Hi tiene que quedar por DEBAJO */
      radioMin: dMax > 0 ? dMax * S.factorR : 0
    };
  }

  /* Radios y anchuras disponibles de una familia, para poder decir si encaja. */
  function anchurasMM(k) {
    return Object.keys(D[k].anchuras).filter(function (a) { return !esDesignacion(a); }).map(parseFloat);
  }
  function radiosDe(k) {
    var v = D[k], r = {};
    Object.keys(v.anchuras).forEach(function (a) { Object.keys(v.anchuras[a].r).forEach(function (x) { r[x] = 1; }); });
    return Object.keys(r).map(parseFloat);
  }

  /* ¿Cabe el paquete en esta familia? Devuelve los motivos, no un sí o un no pelado:
     el cliente necesita saber QUÉ le sobra, no solo que no vale. */
  function encaja(k) {
    var p = paquete();
    if (!p.hay) return { ok: true, avisa: false, motivos: [] };
    var v = D[k], m = [];
    if (v.altura < p.altoMin)
      m.push('altura interior ' + nm(v.altura) + ' mm y el cable más grueso pide ' + nm(p.altoMin, 1) + ' mm con la reserva del 20 %');
    /* El techo `Hi < D1+D2` NO descarta, y esto costó verlo: aplicarlo como filtro dejaba
       CERO cadenas para un paquete tan normal como 6 cables de ⌀12,5 —los que caben a lo
       ancho son demasiado altos y los de la altura justa no llegan de anchura—. Y no es
       un «no se puede»: Murrplastik lo plantea como pauta de TENDIDO, y para eso vende la
       división interior. Así que sobrepasarlo se avisa y se resuelve con separadores. */
    var aMM = anchurasMM(k);
    if (aMM.length) {
      var aMax = Math.max.apply(null, aMM);
      if (aMax < p.anchoNec)
        m.push('anchura máxima ' + nm(aMax) + ' mm y el paquete pide ' + nm(p.anchoNec) + ' mm en una capa');
    }
    var rr = radiosDe(k), rMax = rr.length ? Math.max.apply(null, rr) : 0;
    if (p.radioMin && rMax && rMax < p.radioMin)
      m.push('radio máximo ' + nm(rMax) + ' mm y el cable pide al menos ' + nm(p.radioMin) + ' mm');
    /* Las familias con la anchura en la designación no se pueden medir con este dato:
       no se marcan como «no cabe», se marcan como no comprobables. */
    var medible = aMM.length > 0;
    return { ok: !m.length, avisa: !medible, motivos: m };
  }

  /* ---------- 2 · instalación: qué se sale de los techos de Murrplastik ---------- */
  function revisaInstalacion() {
    var av = [], L = lim();
    if (S.vel > L.vel) av.push(['crit', 'Velocidad horizontal ' + nm(S.vel, 1) + ' m/s: el máximo ' + L.nombre + ' es ' + nm(L.vel) + ' m/s.']);
    if (S.acel > L.acel) av.push(['crit', 'Aceleración horizontal ' + nm(S.acel, 1) + ' m/s²: el máximo ' + L.nombre + ' es ' + nm(L.acel) + ' m/s².']);
    if (S.acelLat > L.acel) av.push(['warn', 'Aceleración lateral ' + nm(S.acelLat, 1) + ' m/s² por encima de ' + nm(L.acel) + ' m/s². Murrplastik no publica un techo propio para la lateral, así que se compara con el horizontal: hay que confirmarlo con fábrica.']);
    if (S.orient === 'ver') {
      if (S.velV > L.vel) av.push(['crit', 'Velocidad vertical ' + nm(S.velV, 1) + ' m/s por encima de ' + nm(L.vel) + ' m/s.']);
      if (S.acelV > L.acel) av.push(['crit', 'Aceleración vertical ' + nm(S.acelV, 1) + ' m/s² por encima de ' + nm(L.acel) + ' m/s².']);
    }
    if (S.tMin < TEMP.min) av.push(['crit', 'Temperatura mínima ' + nm(S.tMin) + ' °C por debajo de ' + nm(TEMP.min) + ' °C.']);
    if (S.tMax > TEMP.max) av.push(['crit', 'Temperatura máxima ' + nm(S.tMax) + ' °C por encima de ' + nm(TEMP.max) + ' °C.']);
    if (S.tCorta && S.tCorta > TEMP.corta) av.push(['crit', 'Punta de temperatura ' + nm(S.tCorta) + ' °C por encima de ' + nm(TEMP.corta) + ' °C.']);
    if (S.tMax <= S.tMin) av.push(['crit', 'La temperatura máxima tiene que ser mayor que la mínima.']);
    if (S.tCorta && S.tCorta < S.tMax) av.push(['warn', 'La punta de temperatura es menor que la máxima permanente; revísalo.']);
    if (!L.cierto) av.push(['warn', 'Para «' + instLbl() + '» Murrplastik no publica techo propio de velocidad y aceleración: solo los da para autoportante (20 m/s, 50 m/s²) y deslizante (6, 25). Aquí se comprueba con el estricto, que es lo prudente, pero el bueno lo confirma nuestro equipo técnico.']);
    if (!av.length) av.push(['ok', 'Dentro de los márgenes de Murrplastik: hasta ' + nm(L.vel) + ' m/s, ' + nm(L.acel) + ' m/s² y de ' + nm(TEMP.min) + ' a ' + nm(TEMP.max) + ' °C.']);
    return av;
  }
  function instalacionOk() { return !revisaInstalacion().some(function (a) { return a[0] === 'crit'; }); }

  /* ---------- validez de cada paso ---------- */
  function valido(i) {
    switch (PASOS[i]) {
      case 'cables': return S.sinCables || paquete().hay;
      case 'instalacion': return instalacionOk();
      case 'cadena': return !!S.fam;
      case 'anchura': return !!S.anchura;
      case 'radio': return !!S.radio && !!S.tipo;
      case 'longitud': {
        var c = calcula();
        return !!c && c.eslabones > 0 && S.uds > 0 && S.nRr <= c.eslabones;
      }
      default: return true;
    }
  }
  function alcanzable(i) { for (var k = 0; k < i; k++) if (!valido(k)) return false; return true; }

  /* ---------- 6 · cálculo de longitud ----------
     Del recorrido a la longitud: L ≈ S/2 + E + π·R, la relación de manual con el
     desplazamiento del punto fijo sumado. Con el punto fijo centrado E vale 0 y queda
     la fórmula de siempre; con alimentación en el extremo E es medio recorrido, así que
     L ≈ S + π·R. Es una ESTIMACIÓN — el vano sin apoyo y la flecha los valida fábrica. */
  function desplazamiento() {
    if (S.fp === 'centro') return 0;
    if (S.fp === 'extremo') return S.recorrido / 2;
    return S.fpE || 0;
  }
  function calcula() {
    var v = f(); if (!v || !S.radio) return null;
    var R = parseFloat(S.radio), E = desplazamiento(), L;
    if (S.modo === 'rec') L = S.recorrido / 2 + E + Math.PI * R;
    else if (S.modo === 'len') L = S.largo;
    else L = S.eslabRaw * v.paso;
    var eslabones = Math.max(1, Math.ceil(L / v.paso));
    var metros = eslabones / v.eslm;
    var precioM = v.anchuras[S.anchura].p;
    return { L: L, R: R, E: E, eslabones: eslabones, realMM: eslabones * v.paso,
             metros: metros, precioM: precioM, importe: metros * precioM };
  }

  /* ---------- 7 · accesorios ---------- */
  var DEFECTO = { 'Enlaces de cadena': 2, 'Peines sujetacables': 2, 'Separadores': 0, 'Conexión de traviesas': 0 };
  var AYUDA = {
    'Enlaces de cadena': 'Uno en el punto fijo y otro en el punto móvil.',
    'Peines sujetacables': 'Sujeción de los cables en cada extremo.',
    'Separadores': 'Dividen la sección interior. La cantidad depende de cuántos huecos quieras.',
    'Conexión de traviesas': 'Pieza de unión de la traviesa.'
  };
  /* Reglas que OBLIGAN un accesorio. La de las traviesas es de Murrplastik: por encima
     de 246 mm de anchura interior la traviesa necesita conector. Antes los accesorios
     eran todos opcionales y se podía configurar una cadena que no se puede montar. */
  function obligatorios() {
    var o = {};
    if (S.anchura && !esDesignacion(S.anchura) && parseFloat(S.anchura) >= BI_TRAVIESAS)
      o['Conexión de traviesas'] = { min: 1, por: 'Con ' + nm(parseFloat(S.anchura)) + ' mm de anchura interior (≥ ' + BI_TRAVIESAS + ' mm) Murrplastik exige conector de traviesas.' };
    /* Si a la cadena le sobra altura para el paquete, el aviso tiene que llevar a la pieza
       que lo resuelve, no quedarse en un aviso. */
    if (S.fam && separa(S.fam)) {
      var p = paquete();
      o['Separadores'] = { min: 1, por: 'La altura interior (' + nm(D[S.fam].altura) + ' mm) pasa de la suma de tus dos cables más gruesos (' +
        nm(p.altoMax, 1) + ' mm), así que los cables pueden montarse unos sobre otros. Los separadores los mantienen en su carril.' };
    }
    return o;
  }
  function opcionesAcc(cat) {
    var c = f().acc[cat]; if (!c) return [];
    var w = c.w[S.anchura];
    return (w && w.length) ? w : c.g;
  }
  function porAnchura(cat) {
    var c = f().acc[cat];
    return !!(c && c.w[S.anchura] && c.w[S.anchura].length);
  }

  /* ---------- lista de materiales ---------- */
  function bom() {
    var v = f(), c = calcula(), L = [];
    L.push({ ref: v.anchuras[S.anchura].r[S.radio][S.tipo],
             d: 'Cadena ' + S.fam.replace(/_/g, '.') + ' ' + anchRef(S.anchura) + ' ' + (S.tipo === 'R' ? 'R' : S.tipo) + ' ' + pad3(S.radio),
             det: nm(c.eslabones) + ' eslabones · ' + nm(c.metros, 2) + ' m',
             q: S.uds, imp: c.importe * S.uds });
    Object.keys(S.acc).forEach(function (cat) {
      var st = S.acc[cat]; if (!st.qty) return;
      opcionesAcc(cat).forEach(function (o) {
        if (st.sel.indexOf(o.ref) < 0) return;
        L.push({ ref: o.ref, d: o.d, det: cat, q: st.qty * S.uds, imp: o.p * st.qty * S.uds });
      });
    });
    return L;
  }

  /* ---------- comprobaciones orientativas del hueco ---------- */
  function revisa() {
    var av = [], v = f(), c = calcula(), p = paquete();
    if (!v) return av;
    var anchoInt = esDesignacion(S.anchura) ? null : parseFloat(S.anchura);
    if (anchoInt && p.hay) {
      var oc = p.dTot / anchoInt;
      if (oc > 1) {
        var capas = Math.ceil(oc);
        av.push(['crit', 'Los cables suman ' + nm(p.dTot, 1) + ' mm y la anchura interior es ' + nm(anchoInt) + ' mm: no caben en una sola capa. Harían falta ' + capas + ' capas con separación horizontal, o una cadena más ancha.']);
      } else if (oc > HOLGURA) {
        av.push(['warn', 'Ocupación del ' + nm(oc * 100) + ' % de la anchura. El criterio habitual deja un 10 % de holgura, así que va justo.']);
      } else {
        av.push(['ok', 'Ocupación del ' + nm(oc * 100) + ' % de la anchura, con holgura suficiente en una capa.']);
      }
    }
    /* Las dos reglas de altura de Murrplastik, y qué significa que choquen. */
    if (p.hay && v.altura) {
      if (v.altura < p.altoMin)
        av.push(['crit', 'Altura interior ' + nm(v.altura) + ' mm. El cable más grueso (⌀' + nm(p.dMax, 1) +
          ' mm) necesita ' + nm(p.altoMin, 1) + ' mm contando la reserva del 20 % que pide Murrplastik para que el cable pueda moverse.']);
      else if (v.altura >= p.altoMax)
        av.push(['warn', 'Altura interior ' + nm(v.altura) + ' mm y los dos cables más gruesos suman ' + nm(p.altoMax, 1) +
          ' mm. Murrplastik pide Hi < D1 + D2 para que los cables no puedan montarse unos encima de otros: aquí les sobra sitio, así que hacen falta separadores que los mantengan en su carril.']);
      else
        av.push(['ok', 'Altura interior ' + nm(v.altura) + ' mm, entre los ' + nm(p.altoMin, 1) + ' mm que pide el cable más grueso y los ' +
          nm(p.altoMax, 1) + ' mm en que los cables empezarían a poder apilarse.']);
      if (p.altoMin >= p.altoMax)
        av.push(['warn', 'Tus cables son de diámetros muy dispares: el mayor pide al menos ' + nm(p.altoMin, 1) +
          ' mm de alto y la regla Hi < D1 + D2 lo limita a ' + nm(p.altoMax, 1) + ' mm. No hay altura que cumpla las dos, así que la solución no es la altura sino la división interior: separadores por carriles.']);
    }
    if (p.dMax > 0 && c)
      av.push([(c.R < p.radioMin) ? 'warn' : 'ok', 'Radio ' + nm(c.R) + ' mm = ' + nm(c.R / p.dMax, 1) + '× el diámetro del cable más grueso; has pedido un mínimo de ' + nm(S.factorR, 1) + '× (' + nm(p.radioMin) + ' mm). El mínimo real lo fija la ficha del cable.']);
    return av;
  }
  function avisos(av) {
    var ico = { crit: '!', warn: '△', ok: '✓' };
    return av.map(function (a) {
      return el('div', { 'class': 'cpc-av cpc-av--' + a[0] },
        [el('i', { text: ico[a[0]] }), el('span', { text: a[1] })]);
    });
  }

  /* ---------- sección transversal ---------- */
  function seccionSVG() {
    var v = f();
    if (!v || !S.anchura) return '';
    var ancho = esDesignacion(S.anchura) ? v.altura * 2 : parseFloat(S.anchura);
    var alto = v.altura, W = 520, H = 210, m = 44;
    var esc = Math.min((W - 2 * m) / ancho, (H - 2 * m) / Math.max(alto, 1));
    var w = ancho * esc, h = alto * esc, x = (W - w) / 2, y = (H - h) / 2, p = [];
    p.push('<rect x="' + (x - 5) + '" y="' + (y - 5) + '" width="' + (w + 10) + '" height="' + (h + 10) + '" rx="2" fill="none" stroke="#032030" stroke-width="3"/>');
    p.push('<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="rgba(3,32,48,.10)" stroke="currentColor" stroke-width="1.2"/>');
    var lista = [];
    S.cables.forEach(function (c) { for (var i = 0; i < Math.min(c.n, 150); i++) if (c.d > 0) lista.push(c.d); });
    lista.sort(function (a, b) { return b - a; });
    var cx = x, cy = y + h, filaAlt = 0, fuera = 0;
    lista.forEach(function (d) {
      var r = (d * esc) / 2;
      if (cx + 2 * r > x + w) { cy -= filaAlt; cx = x; filaAlt = 0; }
      if (cy - 2 * r < y) { fuera++; return; }
      p.push('<circle cx="' + (cx + r).toFixed(1) + '" cy="' + (cy - r).toFixed(1) + '" r="' + r.toFixed(1) + '" fill="#fff" stroke="#4d6068" stroke-width="1"/>');
      cx += 2 * r; filaAlt = Math.max(filaAlt, 2 * r);
    });
    p.push('<line x1="' + x + '" y1="' + (y + h + 18) + '" x2="' + (x + w) + '" y2="' + (y + h + 18) + '" stroke="#4d6068"/>' +
      '<text x="' + (x + w / 2) + '" y="' + (y + h + 32) + '" text-anchor="middle" font-size="11" fill="#4d6068" font-family="monospace">' + nm(ancho) + ' mm</text>');
    p.push('<line x1="' + (x - 18) + '" y1="' + y + '" x2="' + (x - 18) + '" y2="' + (y + h) + '" stroke="#4d6068"/>' +
      '<text x="' + (x - 24) + '" y="' + (y + h / 2 + 4) + '" text-anchor="end" font-size="11" fill="#4d6068" font-family="monospace">' + nm(alto) + '</text>');
    if (fuera) p.push('<text x="' + (W - 8) + '" y="16" text-anchor="end" font-size="11" fill="#c0392b" font-family="monospace">' + fuera + ' sin sitio</text>');
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Sección interior de ' + nm(ancho) + ' por ' + nm(alto) + ' milímetros">' + p.join('') + '</svg>';
  }

  /* ---------- 5 (bis) · el atajo por referencia ----------
     La tercera puerta de Murrplastik es su clave de pedido, y nuestra tarifa SÍ la trae:
     de las 2.533 referencias de cadena, 1.833 son clave de pedido con el formato
     «032 20 045 080 0» y 700 son número de material «MK80400000017786». Se aceptan las
     dos.

     ⚠ Y hay que indexar las dos NORMALIZADAS. La clave lleva espacios; si se normaliza
     solo lo que teclea el cliente y el índice se guarda tal cual, las 1.833 con espacios
     no se encuentran nunca y el atajo parece que no funciona con casi nada.

     Se indexa por dos claves:
       · compacta — sin separadores, conservando los ceros: «032200450800»
       · laxa     — por bloques y sin ceros de relleno: «32|20|45|80|0»
     La laxa está para el aviso que da Murrplastik en su propio configurador: en anchuras
     y radios de dos cifras hay que anteponer un cero, y quien no lo sepa teclea
     «032 20 45 80 0». Con la clave laxa eso también entra. */
  var INDICE = null;
  function compacta(s) { return String(s || '').toUpperCase().replace(/[\s.\-_/]/g, ''); }
  function laxa(s) {
    return String(s || '').toUpperCase().trim().split(/[\s.\-_/]+/).filter(Boolean)
      .map(function (b) { return /^\d+$/.test(b) ? String(parseInt(b, 10)) : b; }).join('|');
  }
  function indice() {
    if (INDICE) return INDICE;
    INDICE = { c: {}, l: {} };
    Object.keys(D).forEach(function (k) {
      var v = D[k];
      Object.keys(v.anchuras).forEach(function (a) {
        Object.keys(v.anchuras[a].r).forEach(function (r) {
          var t = v.anchuras[a].r[r];
          Object.keys(t).forEach(function (tp) {
            var d = { fam: k, anchura: a, radio: r, tipo: tp };
            INDICE.c[compacta(t[tp])] = d;
            INDICE.l[laxa(t[tp])] = d;
          });
        });
      });
    });
    return INDICE;
  }
  function resuelve(txt) {
    var ix = indice(), c = compacta(txt), l = laxa(txt);
    if (!c) return null;
    if (ix.c[c]) return ix.c[c];
    if (ix.l[l]) return ix.l[l];
    /* Como último recurso, una coincidencia parcial, pero solo si es INEQUÍVOCA. */
    var k = Object.keys(ix.c).filter(function (x) { return x.indexOf(c) >= 0; });
    return k.length === 1 ? ix.c[k[0]] : null;
  }

  /* ============================================================
     PINTADO DE CADA PASO
     ============================================================ */

  function campoNum(id, lbl, get, set, opts) {
    opts = opts || {};
    var inp = el('input', { type: 'number', id: id, step: opts.step || '1', value: String(get()) });
    if (opts.min !== undefined) inp.setAttribute('min', String(opts.min));
    if (opts.max !== undefined) inp.setAttribute('max', String(opts.max));
    inp.addEventListener('input', function () {
      var n = opts.ent ? parseInt(inp.value, 10) : parseFloat(inp.value);
      set(isNaN(n) ? 0 : n);
      guarda();
      if (opts.repinta) pinta(); else { refrescaResumen(); if (opts.tras) opts.tras(); }
    });
    var d = el('div', {}, [el('label', { text: lbl, 'for': id }), inp]);
    if (opts.hint) d.appendChild(el('p', { 'class': 'cpc-hint', style: 'margin:5px 0 0', text: opts.hint }));
    return d;
  }
  /* Cuando una pregunta tiene muchas opciones y son largas, los chips se apilan y se
     comen la ventana: la de apertura, con siete, medía sola más de 200 px. En
     desplegable ocupa una línea y se lee igual de bien. */
  function selector(id, etiqueta, valores, activo, alCambiar) {
    var sel = el('select', { id: id });
    valores.forEach(function (v) {
      var op = el('option', { value: v[0], text: v[1] + (v[2] ? ' — ' + v[2] : '') });
      if (String(activo) === String(v[0])) op.setAttribute('selected', 'selected');
      sel.appendChild(op);
    });
    sel.addEventListener('change', function () { alCambiar(sel.value); });
    return el('div', {}, [el('label', { text: etiqueta, 'for': id }), sel]);
  }

  function chips(valores, activo, alPulsar, clase) {
    var ch = el('div', { 'class': 'cpc-chips' });
    valores.forEach(function (v) {
      var b = el('button', { 'class': 'cpc-chip' + (clase ? ' ' + clase : ''), type: 'button',
        'aria-pressed': String(activo === v[0]) }, v[2] ? [el('span', { text: v[1] }), el('small', { text: v[2] })] : null);
      if (!v[2]) b.textContent = v[1];
      b.addEventListener('click', function () { alPulsar(v[0]); });
      ch.appendChild(b);
    });
    return ch;
  }

  /* ---------- paso 1 · cables ---------- */
  function pintaCables(c) {
    c.innerHTML = '';

    /* el atajo, arriba y pequeño: es para quien ya sabe lo que quiere */
    var atajo = el('div', { 'class': 'cpc-atajo' });
    atajo.appendChild(el('label', { 'for': 'cpc-clave', text: '¿Ya la sabes? Pega la clave de pedido o el número de material' }));
    var fila = el('div', { 'class': 'cpc-atajo__in' });
    var inp = el('input', { type: 'text', id: 'cpc-clave', placeholder: '032 20 045 080 0  ·  MK80400000017786', autocomplete: 'off' });
    var bt = el('button', { 'class': 'cpc-btn cpc-btn--ghost', type: 'button', text: 'Cargar' });
    var msg = el('p', { 'class': 'cpc-hint', style: 'margin:7px 0 0' });
    function busca() {
      var r = resuelve(inp.value);
      if (!r) { msg.textContent = 'No encuentro esa referencia en la tarifa ' + (META.anio || '') + '. Vale la clave de pedido o el número de material, con espacios, guiones o sin nada.'; return; }
      S.fam = r.fam; S.anchura = r.anchura; S.radio = r.radio; S.tipo = r.tipo; S.acc = {};
      msg.textContent = '';
      guarda(); ir(PASOS.indexOf('longitud'));
    }
    bt.addEventListener('click', busca);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); busca(); } });
    fila.appendChild(inp); fila.appendChild(bt);
    atajo.appendChild(fila);
    atajo.appendChild(msg);
    c.appendChild(atajo);

    var tb = el('tbody');
    S.cables.forEach(function (cab, i) {
      function inp2(tipo, val, min, step, cb) {
        var n = el('input', { type: tipo, value: String(val) });
        if (min) n.setAttribute('min', min); if (step) n.setAttribute('step', step);
        n.addEventListener('input', function () { cb(n.value); guarda(); refrescaResumen(); pintaAvisosCables(); dibujaSeccion(); marcaRail(); });
        return n;
      }
      var x = el('button', { 'class': 'cpc-x', type: 'button', text: '×', 'aria-label': 'Quitar cable' });
      x.addEventListener('click', function () { S.cables.splice(i, 1); guarda(); pinta(); });
      tb.appendChild(el('tr', {}, [
        el('td', {}, [inp2('number', cab.n, '1', '1', function (v) { cab.n = parseInt(v, 10) || 0; })]),
        el('td', {}, [inp2('number', cab.d, '0.5', '0.5', function (v) { cab.d = parseFloat(v) || 0; })]),
        el('td', {}, [inp2('text', cab.t, null, null, function (v) { cab.t = v; })]),
        el('td', {}, [x])
      ]));
    });
    var tabla = el('table', { 'class': 'cpc-tab' }, [
      el('thead', {}, [el('tr', {}, [
        el('th', { text: 'Cantidad', style: 'width:96px' }),
        el('th', { text: 'Diámetro (mm)', style: 'width:130px' }),
        el('th', { text: 'Descripción' }),
        el('th', { style: 'width:38px' })
      ])]), tb
    ]);

    var rej = el('div', { 'class': 'cpc-grid2' });
    var izq = el('div', {}, [tabla]);
    var add = el('button', { 'class': 'cpc-add', type: 'button', text: '+ Añadir cable' });
    add.addEventListener('click', function () { S.cables.push({ n: 1, d: 10, t: '' }); guarda(); pinta(); });
    izq.appendChild(add);

    /* El factor de radio mínimo lo fija la ficha del cable, no nosotros: se pregunta. */
    /* El factor de radio y el peso van EN LA MISMA FILA: apilados con su ayuda cada uno
       costaban 60 px de los que no hay. */
    var fila = el('div', { 'class': 'cpc-grid2', style: 'margin-top:18px;align-items:start' });
    var cf = el('div', {});
    cf.appendChild(el('label', { text: 'Radio mínimo que admite el cable' }));
    cf.appendChild(chips(FACTORES_R.map(function (x) { return [x, nm(x, 1) + '× ⌀', null]; }), S.factorR,
      function (v) { S.factorR = v; guarda(); pinta(); }));
    cf.appendChild(el('p', { 'class': 'cpc-hint', text: 'De la ficha del cable. Si no lo sabes, 10×.' }));
    fila.appendChild(cf);

    /* El peso es entrada obligatoria en el configurador de Murrplastik (`maxQInfo`), y
       aquí no se pedía. No lo usamos para validar —no tenemos sus curvas de carga— pero
       sin él nadie puede comprobar el vano sin apoyo, así que se pide y se dice para qué. */
    var cp = el('div', {});
    cp.appendChild(campoNum('cpc-peso', 'Peso de los cables (kg/m)', function () { return S.pesoM; },
      function (x) { S.pesoM = x; }, { step: '0.1', min: 0, tras: pintaAvisosCables,
        hint: 'Con el fluido de las mangueras. Permite comprobar el vano sin apoyo.' }));
    fila.appendChild(cp);
    izq.appendChild(fila);

    var salta = el('label', { 'class': 'cpc-check' });
    var ck = el('input', { type: 'checkbox' });
    if (S.sinCables) ck.setAttribute('checked', 'checked');
    ck.addEventListener('change', function () { S.sinCables = ck.checked; guarda(); pinta(); });
    salta.appendChild(ck);
    salta.appendChild(el('span', { text: 'Todavía no sé qué cables van dentro' }));
    izq.appendChild(salta);
    izq.appendChild(el('p', { 'class': 'cpc-hint', text: 'Seguimos, pero sin recomendarte anchura ni radio.' }));

    izq.appendChild(el('div', { 'class': 'cpc-avisos-cables' }));
    rej.appendChild(izq);

    /* lo que el paquete le pide a la cadena — el resultado de este paso */
    var der = el('div', {});
    var p = paquete();
    if (p.hay) {
      der.appendChild(el('div', { 'class': 'cpc-pide' }, [
        el('div', { 'class': 'k', text: 'Lo que este paquete le pide a la cadena' }),
        el('div', { 'class': 'cpc-lin' }, [el('span', { text: 'Cables' }), el('b', { text: nm(p.n) + ' uds · ' + nm(p.dTot, 1) + ' mm sumados' })]),
        el('div', { 'class': 'cpc-lin' }, [el('span', { text: 'Anchura interior mínima' }), el('b', { text: nm(p.anchoNec) + ' mm' })]),
        el('div', { 'class': 'cpc-lin' }, [el('span', { text: 'Altura interior' }), el('b', { text: 'de ' + nm(p.altoMin, 1) + ' a ' + nm(p.altoMax, 1) + ' mm' })]),
        el('div', { 'class': 'cpc-lin' }, [el('span', { text: 'Radio mínimo' }), el('b', { text: nm(p.radioMin) + ' mm' })])
      ]));
      der.appendChild(el('p', { 'class': 'cpc-hint', text: 'Anchura = suma de diámetros con 10 % de holgura, en una capa. La altura tiene mínimo (cable mayor + 20 % de reserva) y máximo (suma de los dos mayores, o se apilan). Reglas de Murrplastik.' }));
    } else {
      der.appendChild(el('p', { 'class': 'cpc-hint', text: 'En cuanto pongas un diámetro te digo aquí qué anchura, qué alto y qué radio mínimo hacen falta.' }));
    }
    rej.appendChild(der);
    c.appendChild(rej);
    pintaAvisosCables();
  }
  function pintaAvisosCables() {
    var caja = $('.cpc-avisos-cables'); if (!caja) return;
    caja.innerHTML = '';
    var p = paquete();
    if (!p.hay) return;
    var cuantas = Object.keys(D).filter(function (k) { return encaja(k).ok; }).length;
    var av = [[cuantas ? 'ok' : 'crit', cuantas
      ? cuantas + ' de las ' + Object.keys(D).length + ' cadenas de la tarifa admiten este paquete.'
      : 'Ninguna cadena de la tarifa admite este paquete tal cual. Reparte los cables en carriles con separadores, o pídenos una especial.']];
    /* Los topes globales del ChainBuilder: por encima de ahí no hay cadena de catálogo. */
    if (p.anchoNec > BI_TOPE)
      av.push(['crit', 'El paquete pide ' + nm(p.anchoNec) + ' mm de anchura interior y el catálogo de Murrplastik llega a ' + nm(BI_TOPE) + ' mm. Hay que repartir los cables en varias cadenas o en varios niveles.']);
    if (p.altoMin > HI_TOPE)
      av.push(['crit', 'El cable más grueso pide ' + nm(p.altoMin, 1) + ' mm de altura interior y el catálogo llega a ' + nm(HI_TOPE) + ' mm.']);
    if (!(S.pesoM > 0))
      av.push(['warn', 'Falta el peso de los cables. Sin él no se puede comprobar el vano sin apoyo, así que la oferta irá con esa comprobación pendiente.']);
    avisos(av).forEach(function (n) { caja.appendChild(n); });
  }
  function dibujaSeccion() {
    var caja = $('.cpc-seccion'); if (caja) caja.innerHTML = seccionSVG();
  }

  /* ---------- paso 2 · instalación ---------- */
  function pintaInstalacion(cRaiz) {
    cRaiz.innerHTML = '';
    /* Dos columnas: una sola columna con nueve bloques pequeños medía 1.035 px y el
       hueco son 717. Izquierda lo que describe el montaje, derecha los números. */
    var cols = el('div', { 'class': 'cpc-cols' });
    var c = el('div', {}), c2 = el('div', {});
    cols.appendChild(c); cols.appendChild(c2);
    cRaiz.appendChild(cols);

    c.appendChild(el('label', { text: 'Aplicación' }));
    c.appendChild(chips([['hor', 'Horizontal', null], ['ver', 'Vertical', null]], S.orient,
      function (v) {
        if (S.orient === v) return;
        S.orient = v;
        /* Las variantes de instalación dependen de la aplicación, igual que en su
           configurador: si la actual no existe en la nueva, se pasa a la primera. */
        var ok = INSTALACIONES[v].some(function (x) { return x[0] === S.instalacion; });
        if (!ok) S.instalacion = INSTALACIONES[v][0][0];
        guarda(); pinta();
      }));

    c.appendChild(el('label', { style: 'margin-top:26px', text: 'Cómo va montada' }));
    c.appendChild(chips(INSTALACIONES[S.orient], S.instalacion,
      function (v) { S.instalacion = v; guarda(); pinta(); }, 'cpc-chip--sq'));
    c.appendChild(el('p', { 'class': 'cpc-hint', text: 'Las siete variantes de Murrplastik. Decide los techos de velocidad y aceleración con los que se comprueba la dinámica.' }));

    /* ── ambiente ──
       Se pregunta con sus mismas casillas, pero NO filtra: qué familia aguanta qué ambiente
       lo sabe su servidor, no nosotros. Va en la solicitud para que lo valide el técnico. */
    c.appendChild(el('h3', { 'class': 'cpc-sub', text: 'Dónde trabaja' }));
    var rejA = el('div', { 'class': 'cpc-ambiente' });
    AMBIENTE.forEach(function (a) {
      var lb = el('label', { 'class': 'cpc-check' });
      var ck = el('input', { type: 'checkbox' });
      if (S.amb[a[0]]) ck.setAttribute('checked', 'checked');
      ck.addEventListener('change', function () { S.amb[a[0]] = ck.checked; guarda(); pintaAvisosInst(); });
      lb.appendChild(ck);
      lb.appendChild(el('span', { text: a[1] }));
      rejA.appendChild(lb);
    });
    c.appendChild(rejA);
    c.appendChild(el('p', { 'class': 'cpc-hint', text: 'No descarta cadenas: qué serie aguanta cada ambiente no lo publica Murrplastik. Viaja en la solicitud.' }));

    c2.appendChild(el('h3', { 'class': 'cpc-sub', text: 'Material de la cadena' }));
    c2.appendChild(chips(MAT_CADENA, S.matCadena, function (v) { S.matCadena = v; guarda(); pinta(); }, 'cpc-chip--sq'));
    c2.appendChild(el('p', { 'class': 'cpc-hint', text: 'ESD es la disipativa. Es configuración, no una serie distinta.' }));

    c2.appendChild(el('h3', { 'class': 'cpc-sub', text: 'Norma de cliente' + ' (opcional)' }));
    c2.appendChild(chips(NORMAS, S.norma, function (v) { S.norma = v; guarda(); pinta(); }));
    c2.appendChild(el('p', { 'class': 'cpc-hint', text: 'Si tu cliente final exige una, lo comprobamos contra su especificación.' }));

    var L = lim();
    c2.appendChild(el('h3', { 'class': 'cpc-sub', text: 'Dinámica' }));
    var g = el('div', { 'class': 'cpc-grid3' });
    g.appendChild(campoNum('cpc-vel', 'Velocidad horizontal (m/s)', function () { return S.vel; },
      function (v) { S.vel = v; }, { step: '0.1', min: 0, tras: pintaAvisosInst, hint: 'máx. ' + nm(L.vel) + ' ' + L.nombre }));
    g.appendChild(campoNum('cpc-acel', 'Aceleración horizontal (m/s²)', function () { return S.acel; },
      function (v) { S.acel = v; }, { step: '0.5', min: 0, tras: pintaAvisosInst, hint: 'máx. ' + nm(L.acel) + ' ' + L.nombre }));
    g.appendChild(campoNum('cpc-acelat', 'Aceleración lateral (m/s²)', function () { return S.acelLat; },
      function (v) { S.acelLat = v; }, { step: '0.5', min: 0, tras: pintaAvisosInst, hint: 'sin techo publicado' }));
    c2.appendChild(g);

    if (S.orient === 'ver') {
      var g2 = el('div', { 'class': 'cpc-grid3' });
      g2.appendChild(campoNum('cpc-velv', 'Velocidad vertical (m/s)', function () { return S.velV; },
        function (v) { S.velV = v; }, { step: '0.1', min: 0, tras: pintaAvisosInst }));
      g2.appendChild(campoNum('cpc-acelv', 'Aceleración vertical (m/s²)', function () { return S.acelV; },
        function (v) { S.acelV = v; }, { step: '0.5', min: 0, tras: pintaAvisosInst }));
      c2.appendChild(g2);
    }

    c2.appendChild(el('h3', { 'class': 'cpc-sub', text: 'Temperatura de trabajo' }));
    var g3 = el('div', { 'class': 'cpc-grid3' });
    g3.appendChild(campoNum('cpc-tmin', 'Mínima (°C)', function () { return S.tMin; },
      function (v) { S.tMin = v; }, { step: '1', tras: pintaAvisosInst, hint: 'no menos de ' + nm(TEMP.min) }));
    g3.appendChild(campoNum('cpc-tmax', 'Máxima permanente (°C)', function () { return S.tMax; },
      function (v) { S.tMax = v; }, { step: '1', tras: pintaAvisosInst, hint: 'no más de ' + nm(TEMP.max) }));
    g3.appendChild(campoNum('cpc-tcorta', 'Punta, poco tiempo (°C)', function () { return S.tCorta; },
      function (v) { S.tCorta = v; }, { step: '1', tras: pintaAvisosInst, hint: 'no más de ' + nm(TEMP.corta) + '; 0 = sin punta' }));
    c2.appendChild(g3);

    cRaiz.appendChild(el('div', { 'class': 'cpc-avisos-inst' }));
    pintaAvisosInst();
  }
  function pintaAvisosInst() {
    var caja = $('.cpc-avisos-inst'); if (!caja) return;
    caja.innerHTML = '';
    avisos(revisaInstalacion()).forEach(function (n) { caja.appendChild(n); });
    marcaRail();
  }

  /* ---------- paso 3 · la cadena, por NECESIDAD ----------
     No se pregunta la familia. Se pregunta si hay que abrirla y por dónde, y si aprieta el
     precio o la vida útil; la familia sale como resultado. Es lo que hace el configurador
     de Murrplastik, que deduce el modelo de la apertura, el ambiente y el material.

     El «para qué» de cada familia está en window.CPC_FAMILIAS, cosechado de su tienda y de
     la hoja del Bügelsteg. Si ese asset no está, el paso cae al listado de antes: es mejor
     una lista de series que una página en blanco. */
  var FAM = window.CPC_FAMILIAS || {};

  /* Cuánto encaja una familia con la preferencia de apertura que ha pedido el cliente.
     2 = de lleno · 1 = con tolerancia o con duda · 0 = no cumple (se muestra al final).
     NO descarta: las seis opciones de Murrplastik son preferencias con tolerancia
     —«o en ambos lados», «se permite no abrible»— y montarlas como filtro fue mi error.

     `abierta` = sabemos que se abre por traviesas pero no por qué arco, así que nunca
     puntúa 2: no se le promete al cliente lo que no sabemos. */
  function puntuaApertura(fk) {
    var q = S.aperturaQ, a = (FAM[fk] || {}).apertura;
    if (q === 'igual') return { p: 2, nota: '' };
    if (!a) return { p: 1, nota: 'no sabemos si se abre' };
    var abrible = a === 'fuera' || a === 'dentro' || a === 'ambos' || a === 'abierta';
    switch (q) {
      case '0': return a === 'cerrada' ? { p: 2, nota: '' } : { p: 1, nota: 'esta se abre, y pediste preferiblemente sin apertura' };
      case '1': return a === 'cerrada' ? { p: 1, nota: 'no se abre, pero lo permitiste' }
                                       : (a === 'abierta' ? { p: 1, nota: 'se abre, arco por confirmar' } : { p: 2, nota: '' });
      case '2': if (a === 'dentro' || a === 'ambos') return { p: 2, nota: '' };
                return a === 'abierta' ? { p: 1, nota: 'se abre, pero no consta que sea por el interior' }
                                       : { p: 0, nota: 'no abre por el interior' };
      case '3': if (a === 'fuera' || a === 'ambos') return { p: 2, nota: '' };
                return a === 'abierta' ? { p: 1, nota: 'se abre, pero no consta que sea por el exterior' }
                                       : { p: 0, nota: 'no abre por el exterior' };
      case '4': if (a === 'ambos') return { p: 2, nota: '' };
                return a === 'abierta' ? { p: 1, nota: 'se abre, pero no consta que sea por los dos arcos' }
                                       : { p: 0, nota: 'no abre por los dos arcos' };
      case '5': if (!abrible) return { p: 0, nota: 'no es abrible' };
                return a === 'abierta' ? { p: 1, nota: 'se abre, arco por confirmar' } : { p: 2, nota: '' };
    }
    return { p: 2, nota: '' };
  }
  /* El cierre SÍ es un requisito físico: abierta de traviesas o cerrada de tapas son dos
     construcciones distintas. Y las cerradas tienen su propio tope de altura. */
  function sirveCierre(fk) {
    if (S.cierre === 'igual') return { ok: true, nota: '' };
    var f = FAM[fk] || {}, alt = D[fk].altura;
    if (S.cierre === '1') {
      if (f.cierre !== 'cerrada') return { ok: false, nota: 'no tiene versión cerrada' };
      if (alt > HI_CERRADA) return { ok: false, nota: 'las cerradas llegan a ' + HI_CERRADA + ' mm de alto y esta tiene ' + alt };
      return { ok: true, nota: '' };
    }
    return f.cierre === 'cerrada' ? { ok: false, nota: 'es la versión cerrada' } : { ok: true, nota: '' };
  }
  /* Material de traviesa. Solo 12 de 24 familias declaran «plástico o aluminio»; donde no
     consta se deja pasar CON NOTA en vez de descartar a ciegas. */
  function sirveTraviesa(fk) {
    if (S.matTraviesa === '0') return { ok: true, nota: '' };
    var t = (FAM[fk] || {}).traviesa;
    if (!t) return { ok: true, nota: 'material de traviesa sin confirmar' };
    if (S.matTraviesa === '1') return { ok: t === 'ambos' || t === 'plastico', nota: 'solo en aluminio' };
    return t === 'ambos' ? { ok: true, nota: '' } : { ok: false, nota: 'solo en plástico' };
  }

  /* Cómo se llama la apertura de la cadena elegida, para el resumen y la solicitud.
     Se dice lo que ES la cadena, no lo que el cliente pidió: si pidió «me da igual» lo
     que hay que ofertar es la apertura real de la serie. */
  function apertLbl() {
    var f = FAM[S.fam] || {};
    var n = { cerrada: 'cerrada, no se abre', fuera: 'se abre por el arco externo',
              dentro: 'se abre por el arco interno', ambos: 'se abre por los dos arcos',
              abierta: 'abierta, de traviesas (arco por confirmar)' }[f.apertura];
    if (!n) return 'sin dato';
    return n + (f.aperturaSegura === false ? ' — por confirmar' : '');
  }

  /* ¿Le sobra altura a esta cadena para el paquete? Entonces los cables se pueden apilar y
     hace falta división interior. No la descarta: la marca. */
  function separa(k) {
    var p = paquete();
    return !!(p.hay && D[k] && D[k].altura >= p.altoMax);
  }

  function pintaCadena(c) {
    c.innerHTML = '';
    var p = paquete(), L = lim();

    /* Las cuatro preguntas en banda: apiladas se comían 350 px que necesitan las
       tarjetas para caber. */
    var preg = el('div', { 'class': 'cpc-preg' });
    var q1 = el('div', {}), q2 = el('div', {}), q3 = el('div', {}), q4 = el('div', {});
    [q1, q2, q3, q4].forEach(function (x) { preg.appendChild(x); });
    c.appendChild(preg);

    /* ── pregunta 1 · abierta o cerrada ── */
    q1.appendChild(el('label', { text: '¿Abierta o cerrada?' }));
    q1.appendChild(chips(CIERRES, S.cierre, function (v) {
      S.cierre = v;
      if (S.fam && !sirveCierre(S.fam).ok) { S.fam = S.anchura = S.radio = S.tipo = null; S.acc = {}; }
      guarda(); pinta();
    }, 'cpc-chip--sq'));
    q1.appendChild(el('p', { 'class': 'cpc-hint', text: 'Dos construcciones distintas, no un acabado: la cerrada lleva tapas y protege de virutas.' }));

    /* ── pregunta 2 · por dónde hay que abrirla ── */
    q2.appendChild(selector('cpc-apert', '¿Por dónde necesitas abrirla?', APERTURAS, S.aperturaQ,
      function (v) { S.aperturaQ = v; guarda(); pinta(); }));
    q2.appendChild(el('p', { 'class': 'cpc-hint', text: 'Ordenan y avisan, no descartan. Arco externo = fuera de la curva; interno = dentro.' }));

    /* ── pregunta 3 · material de la traviesa ── */
    q3.appendChild(el('label', { text: 'Material de la traviesa' }));
    q3.appendChild(chips(MAT_TRAVIESA, S.matTraviesa, function (v) {
      S.matTraviesa = v;
      if (S.fam && !sirveTraviesa(S.fam).ok) { S.fam = S.anchura = S.radio = S.tipo = null; S.acc = {}; }
      guarda(); pinta();
    }, 'cpc-chip--sq'));
    q3.appendChild(el('p', { 'class': 'cpc-hint', text: 'El travesaño que la cierra por arriba. Aluminio aguanta más; plástico pesa y cuesta menos.' }));

    /* ── pregunta 4 · qué prima ── */
    q4.appendChild(el('label', { text: '¿Qué prima en esta máquina?' }));
    q4.appendChild(chips([
      ['igual', 'Me da igual', 'ordena por precio'],
      ['precio', 'El precio', 'las variantes económicas primero'],
      ['vida', 'La vida útil', 'las de carriles de deslizamiento y tope amortiguado']
    ], S.prioridad, function (v) { S.prioridad = v; guarda(); pinta(); }, 'cpc-chip--sq'));
    if (apoyada())
      c.appendChild(el('div', { 'class': 'cpc-av cpc-av--warn', style: 'margin-top:14px' }, [el('i', { text: '△' }),
        el('span', { text: 'Has dicho «' + instLbl() + '», o sea que la cadena va apoyada. Las que llevan carriles de deslizamiento están hechas para eso y duran más; las demás se desgastan antes. Van marcadas abajo.' })]));

    /* ── el resultado ── */
    var fuera = [], dentro = [];
    Object.keys(D).forEach(function (k) {
      var e = encaja(k);
      if (!e.ok) { fuera.push({ k: k, m: e.motivos }); return; }
      var sc = sirveCierre(k); if (!sc.ok) { fuera.push({ k: k, m: [sc.nota] }); return; }
      var st = sirveTraviesa(k); if (!st.ok) { fuera.push({ k: k, m: [st.nota] }); return; }
      var pa = puntuaApertura(k);
      var f = FAM[k] || {}, pr = Object.keys(D[k].anchuras).map(function (a) { return D[k].anchuras[a].p; });
      var notas = [pa.nota, st.nota].filter(Boolean);
      dentro.push({ k: k, f: f, pa: pa.p, notas: notas, desde: Math.min.apply(null, pr) });
    });
    dentro.sort(function (a, b) {
      /* Primero lo que encaja con la apertura pedida: es la pregunta más concreta. */
      if (a.pa !== b.pa) return b.pa - a.pa;
      if (S.prioridad === 'precio' && !!a.f.economica !== !!b.f.economica) return a.f.economica ? -1 : 1;
      if (S.prioridad === 'vida') {
        var va = (a.f.desliza ? 2 : 0) + (a.f.amortiguada ? 1 : 0), vb = (b.f.desliza ? 2 : 0) + (b.f.amortiguada ? 1 : 0);
        if (va !== vb) return vb - va;
      }
      if (apoyada() && !!a.f.desliza !== !!b.f.desliza) return a.f.desliza ? -1 : 1;
      return a.desde - b.desde;
    });

    c.appendChild(el('h3', { 'class': 'cpc-sub', text: dentro.length ? dentro.length + (dentro.length === 1 ? ' cadena te sirve' : ' cadenas te sirven') + (dentro.length > 6 && !S.verTodas ? ' — estas son las 6 que mejor encajan' : '') : 'Ninguna cadena cumple todo' }));
    if (!dentro.length) {
      c.appendChild(el('div', { 'class': 'cpc-av cpc-av--crit' }, [el('i', { text: '!' }),
        el('span', { text: 'Con ese paquete de cables y esa apertura no queda ninguna. Prueba a poner «me da igual» en la apertura, o cuéntanoslo y buscamos una especial.' })]));
    }
    /* Se enseñan las SEIS que mejor encajan, no las dieciocho: con todas la rejilla
       medía 998 px y el hueco de la ventana son ~694 en total. Están ordenadas por lo
       que has pedido, así que las seis primeras son las que más te valen; las demás
       están a un clic y no se esconde ninguna. */
    var TOPE = 6;
    var muestra = S.verTodas ? dentro : dentro.slice(0, TOPE);
    var rej = el('div', { 'class': 'cpc-cards' });
    muestra.forEach(function (x) {
      var v = D[x.k], f = x.f;
      var hijos = [
        el('span', { 'class': 'cpc-card__alt', text: v.altura + ' mm de alto interior' }),
        el('span', { 'class': 'cpc-card__nom', text: x.k.replace(/_/g, '.') }),
        el('span', { 'class': 'cpc-card__met', text: 'desde ' + eur(x.desde) + '/m · ' + Object.keys(v.anchuras).length + ' anchuras' })
      ];
      /* Las palabras son de Murrplastik, no mías. */
      /* Dos características, no cuatro: con cuatro la rejilla de 18 tarjetas medía
         998 px y el hueco entero son 717. Las demás están en el resumen. */
      (f.car || []).slice(0, 2).forEach(function (t) {
        hijos.push(el('span', { 'class': 'cpc-card__car', text: '· ' + t }));
      });
      if (apoyada() && f.desliza) hijos.push(el('span', { 'class': 'cpc-pill', text: 'para apoyada' }));
      if (S.prioridad === 'precio' && f.economica) hijos.push(el('span', { 'class': 'cpc-pill', text: 'económica' }));
      if (separa(x.k)) hijos.push(el('span', { 'class': 'cpc-pill cpc-pill--req', text: 'con separadores' }));
      /* Las salvedades van escritas, no en un distintivo mudo: el cliente tiene que saber
         EN QUÉ no encaja del todo antes de elegirla. */
      x.notas.forEach(function (t) { hijos.push(el('span', { 'class': 'cpc-card__salvedad', text: '△ ' + t })); });
      var b = el('button', { 'class': 'cpc-card', type: 'button', 'aria-pressed': String(S.fam === x.k) }, hijos);
      b.addEventListener('click', function () {
        if (S.fam !== x.k) { S.fam = x.k; S.anchura = S.radio = S.tipo = null; S.acc = {}; }
        guarda(); pinta(); ir(PASOS.indexOf('anchura'));
      });
      rej.appendChild(b);
    });
    c.appendChild(rej);
    if (dentro.length > TOPE) {
      var mas = el('button', { 'class': 'cpc-btn cpc-btn--ghost', type: 'button', style: 'margin-top:12px',
        text: S.verTodas ? 'Ver solo las ' + TOPE + ' que mejor encajan'
                         : 'Ver las otras ' + (dentro.length - TOPE) + ' que también sirven' });
      mas.addEventListener('click', function () { S.verTodas = !S.verTodas; guarda(); pinta(); });
      c.appendChild(mas);
    }

    if (fuera.length) {
      var det = el('details', { 'class': 'cpc-desc' });
      det.appendChild(el('summary', { text: fuera.length + ' descartadas, y por qué' }));
      fuera.forEach(function (x) {
        det.appendChild(el('div', { 'class': 'cpc-lin' }, [
          el('span', { text: x.k.replace(/_/g, '.') }), el('b', { text: x.m.join(' · ') })]));
      });
      c.appendChild(det);
    }
    /* De dónde sale el dato. Sin esto parece que nos lo inventamos. */
    c.appendChild(el('p', { 'class': 'cpc-hint', style: 'margin-top:22px', text:
      'Características publicadas por Murrplastik. «Por confirmar» = se abre, pero no consta por qué arco.' }));
  }

  /* ---------- paso 4 · anchura, con la recomendada marcada ---------- */
  function pintaAnchura(c) {
    c.innerHTML = '';
    var v = f(), p = paquete();
    var todas = ordNum(Object.keys(v.anchuras));
    /* la recomendada es la más estrecha que admite el paquete: la más barata que vale */
    var reco = null;
    if (p.hay) {
      for (var i = 0; i < todas.length; i++) {
        if (esDesignacion(todas[i])) continue;
        if (parseFloat(todas[i]) >= p.anchoNec) { reco = todas[i]; break; }
      }
      if (reco && !S.anchura) S.anchura = reco;
    }
    var ch = el('div', { 'class': 'cpc-chips' });
    todas.forEach(function (a) {
      var cabe = !p.hay || esDesignacion(a) || parseFloat(a) >= p.anchoNec;
      var b = el('button', { 'class': 'cpc-chip cpc-chip--sq' + (cabe ? '' : ' cpc-chip--no'), type: 'button',
        'aria-pressed': String(S.anchura === a) }, [
        el('span', { text: anchLbl(a) }),
        el('small', { text: eur(v.anchuras[a].p) + '/m' + (a === reco ? ' · recomendada' : cabe ? '' : ' · justa') })
      ]);
      b.addEventListener('click', function () {
        if (S.anchura !== a) { S.anchura = a; S.radio = S.tipo = null; S.acc = {}; }
        guarda(); pinta(); ir(PASOS.indexOf('radio'));
      });
      ch.appendChild(b);
    });
    c.appendChild(ch);
    if (reco) c.appendChild(el('p', { 'class': 'cpc-hint', text: 'La recomendada es la más estrecha que admite tu paquete con el 10 % de holgura, que además es la más barata por metro. Las marcadas «justa» caben pero sin holgura.' }));
    var rej = el('div', { 'class': 'cpc-grid2', style: 'margin-top:24px' });
    rej.appendChild(el('div', { 'class': 'cpc-avisos-anch' }));
    rej.appendChild(el('div', { 'class': 'cpc-sec cpc-seccion' }));
    c.appendChild(rej);
    var caja = $('.cpc-avisos-anch');
    if (caja && S.anchura) avisos(revisa()).forEach(function (n) { caja.appendChild(n); });
    dibujaSeccion();
  }

  /* ---------- paso 5 · radio ---------- */
  function pintaRadio(c) {
    c.innerHTML = '';
    var refs = f().anchuras[S.anchura].r, p = paquete();
    var ch = el('div', { 'class': 'cpc-chips' });
    ordNum(Object.keys(refs)).forEach(function (r) {
      var vale = !p.radioMin || parseFloat(r) >= p.radioMin;
      var b = el('button', { 'class': 'cpc-chip' + (vale ? '' : ' cpc-chip--no'), type: 'button',
        'aria-pressed': String(S.radio === r), text: 'R ' + r + ' mm' + (vale ? '' : ' ·  corto') });
      b.addEventListener('click', function () {
        S.radio = r;
        var t = Object.keys(refs[r]);
        S.tipo = t.indexOf(S.tipo) >= 0 ? S.tipo : t[0];
        guarda(); pinta();
      });
      ch.appendChild(b);
    });
    c.appendChild(ch);
    if (p.radioMin) c.appendChild(el('p', { 'class': 'cpc-hint', text: 'Con ⌀' + nm(p.dMax, 1) + ' mm de cable más grueso y el factor ' + nm(S.factorR, 1) + '× que has indicado, el mínimo es ' + nm(p.radioMin) + ' mm. Los marcados «corto» quedan por debajo.' }));

    if (S.radio) {
      var tipos = Object.keys(refs[S.radio]);
      if (!(tipos.length === 1 && tipos[0] === 'R')) {
        var NOM = { RV: 'Con pretensado (RV)', RK: 'Sin pretensado (RK)', R: 'Estándar' };
        c.appendChild(el('label', { text: 'Pretensado', style: 'margin-top:24px' }));
        var ct = el('div', { 'class': 'cpc-chips' });
        tipos.forEach(function (k) {
          var b = el('button', { 'class': 'cpc-chip', type: 'button', 'aria-pressed': String(S.tipo === k), text: NOM[k] || k });
          b.addEventListener('click', function () { S.tipo = k; guarda(); pinta(); });
          ct.appendChild(b);
        });
        c.appendChild(ct);
        if (f().nota) c.appendChild(el('p', { 'class': 'cpc-hint', text: 'La tarifa indica: mismo precio con y sin pretensado.' }));
      }
      c.appendChild(el('div', { 'class': 'cpc-av cpc-av--ok', style: 'margin-top:22px' }, [
        el('i', { text: '✓' }),
        el('span', { html: 'Referencia de esta combinación: <b class="cpc__mono">' + refs[S.radio][S.tipo] + '</b>' })
      ]));
    }
  }

  /* ---------- paso 6 · longitud, punto fijo y contragiro ---------- */
  function pintaLongitud(c) {
    c.innerHTML = '';
    var v = f();
    var campos = el('div', { 'class': 'cpc-grid3' });
    var sel = el('select', { id: 'cpc-modo' });
    [['rec', 'Por recorrido de la máquina'], ['len', 'Longitud de cadena en mm'], ['esl', 'Número de eslabones']]
      .forEach(function (o) {
        var op = el('option', { value: o[0], text: o[1] });
        if (S.modo === o[0]) op.setAttribute('selected', 'selected');
        sel.appendChild(op);
      });
    sel.addEventListener('change', function () { S.modo = sel.value; guarda(); pinta(); });
    campos.appendChild(el('div', {}, [el('label', { text: 'Cómo la defines', 'for': 'cpc-modo' }), sel]));

    if (S.modo === 'rec') campos.appendChild(campoNum('cpc-rec', 'Recorrido S (mm)', function () { return S.recorrido; },
      function (x) { S.recorrido = x; }, { step: '10', min: 1, tras: pintaAvisosLongitud }));
    if (S.modo === 'len') campos.appendChild(campoNum('cpc-len', 'Longitud L (mm)', function () { return S.largo; },
      function (x) { S.largo = x; }, { step: '10', min: 1, tras: pintaAvisosLongitud }));
    if (S.modo === 'esl') campos.appendChild(campoNum('cpc-esl', 'Eslabones', function () { return S.eslabRaw; },
      function (x) { S.eslabRaw = x; }, { step: '1', min: 1, ent: true, tras: pintaAvisosLongitud }));
    campos.appendChild(campoNum('cpc-uds', 'Unidades iguales', function () { return S.uds; },
      function (x) { S.uds = x; }, { step: '1', min: 1, ent: true }));
    c.appendChild(campos);

    /* Punto fijo: mueve la longitud y antes no se preguntaba. Con alimentación en el
       extremo la cadena pasa de S/2 a S entero, que es casi el doble. */
    if (S.modo === 'rec') {
      c.appendChild(el('h3', { 'class': 'cpc-sub', text: 'Posición del punto fijo' }));
      c.appendChild(chips([
        ['centro', 'Centrado', 'sin desplazamiento'],
        ['desc', 'Descentrado', 'lo indicas en mm'],
        ['extremo', 'Alimentación en el extremo', 'E = S/2']
      ], S.fp, function (x) { S.fp = x; guarda(); pinta(); }, 'cpc-chip--sq'));
      if (S.fp === 'desc') {
        var g = el('div', { 'class': 'cpc-grid3' });
        g.appendChild(campoNum('cpc-fpe', 'Desplazamiento E (mm)', function () { return S.fpE; },
          function (x) { S.fpE = x; }, { step: '10', min: 0, tras: pintaAvisosLongitud }));
        c.appendChild(g);
      }
      c.appendChild(el('p', { 'class': 'cpc-hint', text: 'E es la distancia del punto fijo al centro del recorrido. Centrado es lo normal; con la alimentación en un extremo hace falta casi el doble de cadena.' }));
    }

    c.appendChild(el('h3', { 'class': 'cpc-sub', text: 'Eslabones de contragiro' }));
    var g2 = el('div', { 'class': 'cpc-grid3' });
    g2.appendChild(campoNum('cpc-nrr', 'Cantidad nRr', function () { return S.nRr; },
      function (x) { S.nRr = x; }, { step: '1', min: 0, ent: true, tras: pintaAvisosLongitud }));
    c.appendChild(g2);
    c.appendChild(el('p', { 'class': 'cpc-hint', text: 'Van incluidos en la longitud total, no se suman aparte. Tienen que ser como máximo el número de eslabones de la cadena.' }));

    c.appendChild(el('div', { 'class': 'cpc-avisos-largo' }));
    pintaAvisosLongitud();
  }
  function pintaAvisosLongitud() {
    var caja = $('.cpc-avisos-largo'); if (!caja) return;
    caja.innerHTML = '';
    var c = calcula(), v = f(); if (!c) return;
    var av = [];
    if (S.modo === 'rec') {
      var e = c.E ? ' + ' + nm(c.E) : '';
      av.push(['ok', 'Estimación L ≈ S/2' + (c.E ? ' + E' : '') + ' + π·R = ' + nm(S.recorrido) + '/2' + e + ' + π·' + nm(c.R) +
        ' = ' + nm(c.L) + ' mm, redondeado a ' + nm(c.eslabones) + ' eslabones de ' + nm(v.paso, 1) + ' mm = ' +
        nm(c.realMM) + ' mm. Es orientativo: el vano sin apoyo lo valida el fabricante.']);
    } else {
      av.push(['ok', nm(c.eslabones) + ' eslabones de ' + nm(v.paso, 1) + ' mm = ' + nm(c.realMM) +
        ' mm. Se venden eslabones enteros, así que la longitud se redondea al alza.']);
    }
    if (S.nRr > c.eslabones)
      av.push(['crit', 'Has puesto ' + nm(S.nRr) + ' eslabones de contragiro y la cadena tiene ' + nm(c.eslabones) + '. nRr no puede pasar de n.']);
    avisos(av).forEach(function (n) { caja.appendChild(n); });
    marcaRail();
  }

  /* ---------- paso 7 · accesorios, con los que obliga la configuración ---------- */
  function pintaAccesorios(c) {
    c.innerHTML = '';
    var obl = obligatorios(), hay = false;
    Object.keys(DEFECTO).forEach(function (cat) {
      var ops = opcionesAcc(cat); if (!ops.length) return;
      hay = true;
      var pa = porAnchura(cat), ob = obl[cat];
      if (!S.acc[cat]) S.acc[cat] = { sel: pa ? ops.map(function (o) { return o.ref; }) : [ops[0].ref], qty: DEFECTO[cat] };
      var st = S.acc[cat];
      if (ob && st.qty < ob.min) st.qty = ob.min;
      var caja = el('div', { style: 'margin-bottom:30px' });
      var h = el('label', { style: 'font-size:15px;margin-bottom:3px' });
      h.appendChild(document.createTextNode(cat));
      if (pa) h.appendChild(el('span', { 'class': 'cpc-pill', style: 'margin-left:9px', text: 'según anchura' }));
      if (ob) h.appendChild(el('span', { 'class': 'cpc-pill cpc-pill--req', style: 'margin-left:9px', text: 'obligatorio' }));
      caja.appendChild(h);
      caja.appendChild(el('p', { 'class': 'cpc-hint', style: 'margin:0 0 10px', text: AYUDA[cat] }));
      if (ob) caja.appendChild(el('div', { 'class': 'cpc-av cpc-av--warn', style: 'margin:0 0 12px' },
        [el('i', { text: '△' }), el('span', { text: ob.por })]));
      var ch = el('div', { 'class': 'cpc-chips' });
      ops.forEach(function (o) {
        var on = st.sel.indexOf(o.ref) >= 0;
        var b = el('button', { 'class': 'cpc-chip cpc-chip--sq', type: 'button', 'aria-pressed': String(on) }, [
          el('span', { text: o.d }),
          el('small', { 'class': 'cpc__mono', text: o.ref + ' · ' + eur(o.p) })
        ]);
        b.addEventListener('click', function () {
          var i = st.sel.indexOf(o.ref);
          if (pa) {
            if (i >= 0) { if (ob && st.sel.length === 1) return; st.sel.splice(i, 1); }
            else st.sel.push(o.ref);
          } else { st.sel = i >= 0 && !ob ? [] : [o.ref]; }
          guarda(); pinta();
        });
        ch.appendChild(b);
      });
      caja.appendChild(ch);
      caja.appendChild(el('label', { text: 'Cantidad por cadena', style: 'margin-top:11px' }));
      var q = el('input', { type: 'number', min: String(ob ? ob.min : 0), step: '1', value: String(st.qty), style: 'max-width:140px' });
      q.addEventListener('input', function () {
        var n = parseInt(q.value, 10) || 0;
        /* Si es obligatorio hay que DEVOLVER el mínimo a la casilla, no solo forzarlo en
           el estado: dejarla en 0 mientras la lista de materiales lleva 1 es peor que no
           corregirlo, porque el número que el cliente ve no es el que se le va a ofertar. */
        if (ob && n < ob.min) { n = ob.min; q.value = String(n); }
        st.qty = n; guarda(); refrescaResumen();
      });
      caja.appendChild(q);
      c.appendChild(caja);
    });
    if (!hay) c.appendChild(el('p', { 'class': 'cpc-hint', text: 'La tarifa no trae accesorios para esta familia.' }));
  }

  /* ---------- paso 8 · resumen + solicitud ---------- */
  function pintaResumen(c) {
    c.innerHTML = '';
    var v = f(), cal = calcula(), lineas = bom();
    var total = lineas.reduce(function (s, x) { return s + x.imp; }, 0);
    var ref = v.anchuras[S.anchura].r[S.radio][S.tipo];
    var L = lim();

    var izq = el('div', {});
    izq.appendChild(el('div', { 'class': 'cpc-ref' }, [
      el('div', { 'class': 'k', text: 'Referencia Murrplastik' }),
      el('div', { 'class': 'v', text: ref }),
      el('div', { 'class': 'd', text: S.fam.replace(/_/g, '.') + ' ' + anchRef(S.anchura) + ' ' + (S.tipo === 'R' ? 'R' : S.tipo) + ' ' + pad3(S.radio) })
    ]));

    var det = el('div', { style: 'margin-top:22px' });
    var filas = [
      ['Familia', S.fam.replace(/_/g, '.') + ' · ' + v.linea],
      ['Anchura interior', anchLbl(S.anchura)],
      ['Radio de curvatura', S.radio + ' mm'],
      ['Instalación', instLbl()],
      ['Apertura', apertLbl()],
      ['Material', (MAT_CADENA.filter(function (m) { return m[0] === S.matCadena; })[0] || ['', '?'])[1] +
        ' · traviesa ' + (MAT_TRAVIESA.filter(function (m) { return m[0] === S.matTraviesa; })[0] || ['', '?'])[1].toLowerCase()],
      ['Dinámica', nm(S.vel, 1) + ' m/s · ' + nm(S.acel, 1) + ' m/s²'],
      ['Temperatura', nm(S.tMin) + ' a ' + nm(S.tMax) + ' °C' + (S.tCorta ? ' (punta ' + nm(S.tCorta) + ')' : '')],
      ['Longitud de cadena', nm(cal.realMM) + ' mm'],
      ['Eslabones', nm(cal.eslabones)]
    ];
    if (ambLista().length) filas.push(['Ambiente', ambLista().join(' · ')]);
    if (S.norma) filas.push(['Norma de cliente', (NORMAS.filter(function (n) { return n[0] === S.norma; })[0] || ['', ''])[1]]);
    if (S.modo === 'rec') filas.push(['Punto fijo', S.fp === 'centro' ? 'centrado' : S.fp === 'extremo' ? 'alimentación en el extremo (E = ' + nm(cal.E) + ' mm)' : 'descentrado E = ' + nm(cal.E) + ' mm']);
    if (S.nRr) filas.push(['Eslabones de contragiro', nm(S.nRr)]);
    filas.push(['Metros facturables', nm(cal.metros, 2) + ' m']);
    filas.push(['Precio de tarifa', eur(cal.precioM) + '/m']);
    filas.push(['Unidades', nm(S.uds)]);
    filas.forEach(function (r) {
      det.appendChild(el('div', { 'class': 'cpc-lin' }, [el('span', { text: r[0] }), el('b', { text: r[1] })]));
    });
    izq.appendChild(det);

    var tb = el('tbody');
    lineas.forEach(function (l) {
      tb.appendChild(el('tr', {}, [
        el('td', {}, [el('span', { text: l.d }), el('span', { 'class': 'sub', text: l.ref + (l.det ? ' · ' + l.det : '') })]),
        el('td', { text: nm(l.q) }),
        el('td', { text: eur(l.imp) })
      ]));
    });
    izq.appendChild(el('h3', { style: 'margin-top:30px;font-size:17px', text: 'Lista de materiales' }));
    izq.appendChild(el('div', { 'class': 'cpc-scroll', style: 'margin-top:12px' }, [
      el('table', { 'class': 'cpc-bom' }, [
        el('thead', {}, [el('tr', {}, [el('th', { text: 'Artículo' }), el('th', { text: 'Cant.' }), el('th', { text: 'Importe' })])]),
        tb])
    ]));
    izq.appendChild(el('div', { 'class': 'cpc-tot' }, [
      el('span', { 'class': 'k', text: 'Total PVP tarifa' }),
      el('span', { 'class': 'v', html: eur(total) + ' <small>sin IVA</small>' })
    ]));
    /* A un cliente con cuenta de empresa hay que decirle que esto es tarifa y no
       su precio. Su neto NO se puede calcular aquí: los importes salen del asset
       de la tarifa, no de productos de Shopify, así que su grupo de descuento no
       está al alcance del tema. Prometer un neto que no sabemos sería peor. */
    izq.appendChild(el('p', { 'class': 'cpc-nota-precio', text:
      SESION === 'b2b'
        ? 'Es el PVP de tarifa. Tu precio con el descuento de tu cuenta se confirma en la oferta.'
        : SESION === 'cliente'
          ? 'PVP de tarifa sin IVA. Si tienes cuenta de empresa, tus condiciones se aplican en la oferta.'
          : 'PVP de tarifa sin IVA.' }));

    var der = el('div', {});
    der.appendChild(el('div', { 'class': 'cpc-sec', html: seccionSVG() }));
    avisos(revisa()).forEach(function (n) { der.appendChild(n); });
    avisos(revisaInstalacion()).forEach(function (n) { der.appendChild(n); });
    /* Compartir y recuperar: el estado va en el hash, así que el enlace vale para
       retomarlo mañana o para mandárnoslo tal cual. Sin login ni base de datos. */
    var bc = el('button', { 'class': 'cpc-btn cpc-btn--ghost', type: 'button', text: 'Copiar enlace de esta configuración' });
    bc.addEventListener('click', function () {
      guarda(true);
      var u = location.href;
      if (navigator.clipboard) navigator.clipboard.writeText(u).then(function () { bc.textContent = 'Enlace copiado'; },
        function () { bc.textContent = 'Copia la barra de direcciones'; });
      else bc.textContent = 'Copia la barra de direcciones';
      setTimeout(function () { bc.textContent = 'Copiar enlace de esta configuración'; }, 2600);
    });
    der.appendChild(el('div', { style: 'margin-top:18px' }, [bc]));
    der.appendChild(el('p', { 'class': 'cpc-hint', text: 'El enlace lleva la configuración dentro. Guárdalo o pásanoslo y se abre tal cual la has dejado.' }));

    c.appendChild(el('div', { 'class': 'cpc-res' }, [izq, der]));

    /* El formulario vive en el Liquid (form 'contact') y está fuera del asistente
       a propósito: un <form> anidado rompió el botón de añadir a la cesta en su día.
       Aquí solo se rellenan sus campos ocultos. */
    var caja = document.getElementById('cpc-solicitud');
    if (caja) { caja.hidden = false; c.appendChild(caja); }
    var res = texto(lineas, total);
    var oc = { Referencia: ref, Configuracion: res, body: 'Solicitud de cadena portacables — ' + ref };
    Object.keys(oc).forEach(function (k) {
      var i = document.querySelector('[data-cpc-campo="' + k + '"]');
      if (i) i.value = oc[k];
    });
    var pre = document.querySelector('[data-cpc-preview]');
    if (pre) pre.textContent = res;
  }

  /* ---------- texto plano de la configuración ---------- */
  function texto(lineas, total) {
    var v = f(), c = calcula(), L = [], lm = lim();
    L.push('CADENA PORTACABLES · configuración');
    L.push('Familia .......... ' + S.fam.replace(/_/g, '.') + '  (' + v.linea + ', ' + v.altura + ' mm de alto)');
    L.push('Anchura interior . ' + anchLbl(S.anchura));
    L.push('Radio ............ ' + S.radio + ' mm');
    L.push('Pretensado ....... ' + (S.tipo === 'RV' ? 'con (RV)' : S.tipo === 'RK' ? 'sin (RK)' : 'estándar'));
    L.push('Instalación ...... ' + instLbl() + ' (' + (S.orient === 'ver' ? 'vertical' : 'horizontal') + ')');
    L.push('Material ......... cadena ' + (MAT_CADENA.filter(function (m) { return m[0] === S.matCadena; })[0] || ['', '?'])[1] +
      ', traviesa ' + (MAT_TRAVIESA.filter(function (m) { return m[0] === S.matTraviesa; })[0] || ['', '?'])[1].toLowerCase());
    if (ambLista().length) L.push('Ambiente ......... ' + ambLista().join(', '));
    if (S.norma) L.push('Norma de cliente . ' + (NORMAS.filter(function (n) { return n[0] === S.norma; })[0] || ['', ''])[1]);
    L.push('Apertura ......... ' + apertLbl());
    var fam = FAM[S.fam] || {};
    if (fam.car && fam.car.length) L.push('Serie ............ ' + fam.car.join('; '));
    L.push('Dinámica ......... ' + nm(S.vel, 1) + ' m/s, ' + nm(S.acel, 1) + ' m/s² hor.' +
      (S.acelLat ? ', ' + nm(S.acelLat, 1) + ' m/s² lat.' : '') +
      (S.orient === 'ver' ? ', ' + nm(S.velV, 1) + ' m/s y ' + nm(S.acelV, 1) + ' m/s² vert.' : ''));
    L.push('Temperatura ...... de ' + nm(S.tMin) + ' a ' + nm(S.tMax) + ' °C' + (S.tCorta ? ', punta ' + nm(S.tCorta) + ' °C' : ''));
    L.push('Longitud ......... ' + nm(c.realMM) + ' mm  (' + nm(c.eslabones) + ' eslabones, ' + nm(c.metros, 2) + ' m)');
    if (S.modo === 'rec') {
      L.push('Recorrido ........ ' + nm(S.recorrido) + ' mm');
      L.push('Punto fijo ....... ' + (S.fp === 'centro' ? 'centrado' : S.fp === 'extremo' ? 'alimentación en el extremo, E = ' + nm(c.E) + ' mm' : 'descentrado, E = ' + nm(c.E) + ' mm'));
    }
    if (S.nRr) L.push('Contragiro ....... ' + nm(S.nRr) + ' eslabones (incluidos en la longitud)');
    L.push('Unidades ......... ' + nm(S.uds));
    var cab = S.cables.filter(function (x) { return x.d > 0; });
    if (cab.length) {
      L.push('Cables ........... ' + cab.map(function (x) {
        return x.n + '×⌀' + nm(x.d, 1) + (x.t ? ' ' + x.t : '');
      }).join(', '));
      var p = paquete();
      L.push('                   suman ' + nm(p.dTot, 1) + ' mm; radio mínimo pedido ' + nm(S.factorR, 1) + '× = ' + nm(p.radioMin) + ' mm');
      L.push('                   altura interior admisible ' + nm(p.altoMin, 1) + ' a ' + nm(p.altoMax, 1) + ' mm (Hi < D1+D2)');
    } else if (S.sinCables) {
      L.push('Cables ........... sin definir todavía');
    }
    L.push(S.pesoM > 0
      ? 'Peso de cables ... ' + nm(S.pesoM, 1) + ' kg/m (fluido incluido)'
      : 'Peso de cables ... SIN INDICAR — falta para comprobar el vano sin apoyo');
    L.push('');
    L.push('LISTA DE MATERIALES');
    lineas.forEach(function (l) {
      var r = l.ref; while (r.length < 20) r += ' ';
      var q = String(l.q); while (q.length < 4) q = ' ' + q;
      L.push(r + ' ' + q + ' ud  ' + l.d);
    });
    L.push('');
    L.push('Total PVP tarifa ' + (META.anio || '') + ' sin IVA: ' + eur(total));
    if (SESION === 'b2b') L.push('Cuenta de empresa: aplicar su grupo de descuento.');
    L.push('Precios de tarifa. Configuración pendiente de validación técnica:');
    L.push('no comprueba vano sin apoyo, flecha, carga admisible ni vida útil.');
    return L.join('\n');
  }

  /* ---------- guardar y recuperar en la URL ----------
     Sin login y sin base de datos: el estado entero cabe en el hash. Se escribe solo
     cuando el usuario ha tocado algo, y NUNCA si el hash es el del acuse de recibo del
     formulario: el Liquid compara `location.hash` con el id del form para decidir si
     enseña el «gracias», y pisarlo lo dejaría mudo. */
  var CLAVE = '#cpc=';
  function b64(s) {
    return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function deB64(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    return decodeURIComponent(escape(atob(s)));
  }
  var tocado = false;
  function guarda(forzar) {
    tocado = true;
    if (!forzar && /^#cpc-form-/.test(location.hash)) return;
    try {
      history.replaceState(null, '', location.pathname + location.search + CLAVE + b64(JSON.stringify(S)));
    } catch (e) { /* hash demasiado largo o navegador quisquilloso: no es crítico */ }
  }
  function recupera() {
    var h = location.hash;
    if (h.indexOf(CLAVE) !== 0) return false;
    try {
      var o = JSON.parse(deB64(h.slice(CLAVE.length)));
      if (!o || typeof o !== 'object') return false;
      var base = estadoInicial();
      Object.keys(base).forEach(function (k) { if (o[k] !== undefined && o[k] !== null) base[k] = o[k]; });
      /* Si la tarifa se ha regenerado, la familia guardada puede no existir ya. */
      if (base.fam && !D[base.fam]) { base.fam = base.anchura = base.radio = base.tipo = null; base.acc = {}; }
      if (base.fam && base.anchura && !D[base.fam].anchuras[base.anchura]) { base.anchura = base.radio = base.tipo = null; base.acc = {}; }
      if (base.fam && base.anchura && base.radio && !D[base.fam].anchuras[base.anchura].r[base.radio]) { base.radio = base.tipo = null; }
      if (!Array.isArray(base.cables) || !base.cables.length) base.cables = estadoInicial().cables;
      S = base;
      return true;
    } catch (e) { return false; }
  }

  /* ---------- navegación ---------- */
  var PINTORES = { cables: pintaCables, instalacion: pintaInstalacion, cadena: pintaCadena,
                   anchura: pintaAnchura, radio: pintaRadio, longitud: pintaLongitud,
                   accesorios: pintaAccesorios, resumen: pintaResumen };

  /* ---------- que el asistente quepa en la ventana ----------
     El marco tiene que medir lo que queda de alto por debajo de la cabecera del tema.
     No se puede hacer con `100dvh` a secas: la cabecera es sticky y de alto variable,
     así que el fondo del marco se saldría por abajo justo lo que ella ocupa.

     Y hay que descontarla de verdad, no a ojo: se buscan los elementos fijos o sticky
     que estén pegados arriba y se toma el más alto. */
  function tapaArriba() {
    var alto = 0;
    var cand = document.querySelectorAll('header,[role=banner],.header,#shopify-section-header,[class*="site-header"]');
    for (var i = 0; i < cand.length; i++) {
      var cs = window.getComputedStyle(cand[i]);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      var r = cand[i].getBoundingClientRect();
      if (r.height > 0 && r.top <= 1) alto = Math.max(alto, r.height);
    }
    return alto;
  }
  function mide() {
    var m = $('.cpc-marco'); if (!m) return;
    var tapa = tapaArriba();
    raiz.style.setProperty('--cpc-alto', Math.max(420, window.innerHeight - tapa) + 'px');
    m.style.scrollMarginTop = tapa + 'px';
  }
  /* La cabecera se encoge en cuanto se empieza: si ocupa 200 px, son 200 px que el
     asistente no tiene. Se mantiene en el primer paso para que la página siga
     presentándose, y se recoge al avanzar. */
  function cabecera() {
    var h = $('.cpc-head'); if (!h) return;
    if (paso > 0) h.classList.add('cpc-head--min'); else h.classList.remove('cpc-head--min');
  }

  function ir(i) {
    if (i < 0 || i >= PASOS.length) return;
    if (i > paso && !valido(paso)) return;
    if (!alcanzable(i)) return;
    paso = i; pinta();
    cabecera(); mide();
    /* Cada paso empieza por arriba: si el anterior se había desplazado, el nuevo
       aparecería por su mitad. */
    var cuerpo = $('.cpc-body'); if (cuerpo) cuerpo.scrollTop = 0;
    var m = $('.cpc-marco') || raiz;
    if (m.getBoundingClientRect().top < 0) m.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function marcaRail() {
    $$('.cpc-rail__i').forEach(function (b, i) {
      if (i === paso) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      b.setAttribute('data-done', String(i < paso && valido(i)));
      if (alcanzable(i)) b.removeAttribute('disabled'); else b.setAttribute('disabled', '');
    });
    var sig = $('[data-cpc-siguiente]');
    if (sig && !sig.hidden) {
      if (valido(paso)) sig.removeAttribute('disabled'); else sig.setAttribute('disabled', '');
    }
  }

  function pinta() {
    $$('.cpc-step').forEach(function (n, i) { n.hidden = i !== paso; });
    var actual = PASOS[paso];
    var cuerpo = $('[data-cpc-cuerpo="' + actual + '"]');
    if (cuerpo && PINTORES[actual]) PINTORES[actual](cuerpo);

    var atras = $('[data-cpc-atras]'), sig = $('[data-cpc-siguiente]');
    atras.hidden = paso === 0;
    sig.hidden = paso === PASOS.length - 1;
    if (!sig.hidden) sig.textContent = paso === PASOS.length - 2 ? 'Ver resumen' : 'Siguiente';
    marcaRail();
    refrescaResumen();
  }

  function refrescaResumen() {
    var n = $('[data-cpc-sum]'); if (!n) return;
    n.innerHTML = '';
    var p = paquete();
    var trozos = [];
    if (p.hay) trozos.push(['Cables', nm(p.n) + ' · ' + nm(p.dTot, 1) + ' mm']);
    if (!S.fam) {
      if (!trozos.length) n.appendChild(el('span', { text: 'Empieza por los cables que van dentro' }));
      else trozos.forEach(function (t) { n.appendChild(el('span', { html: t[0] + ' <b>' + t[1] + '</b>' })); });
      return;
    }
    trozos.push(['Familia', S.fam.replace(/_/g, '.')]);
    if (S.anchura) trozos.push(['Anchura', anchLbl(S.anchura)]);
    if (S.radio) trozos.push(['Radio', S.radio + ' mm']);
    var c = calcula();
    if (c) trozos.push(['Longitud', nm(c.realMM) + ' mm']);
    trozos.forEach(function (t) { n.appendChild(el('span', { html: t[0] + ' <b>' + t[1] + '</b>' })); });
    if (c) {
      var total = bom().reduce(function (s, x) { return s + x.imp; }, 0);
      n.appendChild(el('span', { html: '<b class="imp">' + eur(total) + '</b>' }));
    }
  }

  /* ---------- arranque ---------- */
  $$('.cpc-rail__i').forEach(function (b, i) {
    b.addEventListener('click', function () { ir(i); });
  });
  $('[data-cpc-atras]').addEventListener('click', function () { ir(paso - 1); });
  $('[data-cpc-siguiente]').addEventListener('click', function () { ir(paso + 1); });
  var mt = $('[data-cpc-meta]');
  if (mt && META.referencias) {
    mt.innerHTML = '<span><b>' + nm(META.familias) + '</b> familias</span>' +
      '<span><b>' + META.referencias.toLocaleString('es-ES') + '</b> referencias</span>' +
      '<span>tarifa <b>PVP ' + (META.anio || '') + '</b></span>';
  }
  /* Si el enlace traía una configuración, se abre donde se pueda llegar. */
  if (recupera()) {
    var ult = 0;
    for (var i = 0; i < PASOS.length; i++) if (alcanzable(i)) ult = i;
    paso = ult;
  }
  pinta();
  cabecera(); mide();
  /* Al girar el móvil o cambiar el zoom cambia el alto útil; y la cabecera del tema
     puede encogerse al hacer scroll, así que también se remide entonces. */
  var espera = null;
  function remide() { if (espera) return; espera = setTimeout(function () { espera = null; mide(); }, 120); }
  window.addEventListener('resize', remide);
  window.addEventListener('scroll', remide, { passive: true });
})();
